import { render, staticRenderFns } from "./testDataAdd.vue?vue&type=template&id=094b2aac&scoped=true"
import script from "./testDataAdd.vue?vue&type=script&lang=js"
export * from "./testDataAdd.vue?vue&type=script&lang=js"
import style0 from "./testDataAdd.vue?vue&type=style&index=0&id=094b2aac&prod&lang=less&scoped=true"
import style1 from "./testDataAdd.vue?vue&type=style&index=1&id=094b2aac&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "094b2aac",
  null
  
)

export default component.exports